import styled from 'styled-components';

import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const breakpoints = {
    tablet: '1023px',
    mobile: '767px',
};

export const LineContainer = styled(GridContainer)`
    flex-direction: column;
    padding-left: 0;
    padding-right: 0;
    width: 100%;
`;

export const LineTitle = styled.h2`
    margin-bottom: 8px;
    ${FONTS.H2};
    color: ${COLORS.TextPrimary};

    @media (max-width: ${breakpoints.tablet}) {
        ${FONTS.H3};
    }

    @media (max-width: ${breakpoints.mobile}) {
        ${FONTS.H5}
}
`;

export const LineBody = styled.div`
    max-width: 530px;
    ${FONTS.XS};
    color: ${COLORS.TextSecondary};

    a {
        ${FONTS.MediumXS};
        color: ${COLORS.Link};
        transition: 0.3s;

        &:hover {
            color: ${COLORS.Brand_Blue};
        }
    }
`;

export const CustomSwiper = styled(NukaCarousel)`
    padding-left: 0 !important;
    padding-right: 0 !important;

    & section,
    & div {
        outline: none;
    }

    & > section > div.slider-frame {
        padding: 24px 0 !important;
    }
`;

export const NoSwiperContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;

    & > div {
        &:not(:last-child) {
            margin-right: 20px;
        }
    }
`;

export const NotFoundTitle = styled.p`
    ${FONTS.S};
    color: ${COLORS.GRAY_DARK};
    margin: 16px 0;
`;
